// import external dependencies

import "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Import everything from autoload
import "./autoload/_foundation.js";
import "./modules/_sticky-header";
import "./modules/_mobile-menu";
import "./modules/_map";

const grid = document.querySelector(".grid");
const header = document.querySelector(".header");
const mainContent = document.querySelector(".site-content");
const footer = document.querySelector(".footer");

const tl = gsap.timeline({ smoothChildTiming: true, ease: "back" });

function gridAnimation() {
	tl.fromTo(grid, 1.2, { height: "0%" }, { height: "100%" })
		.fromTo(header, 0.5, { opacity: "0" }, { opacity: "1" })
		.fromTo(mainContent, 1, { opacity: "0" }, { opacity: "1" })
		.fromTo(footer, 1, { opacity: "0" }, { opacity: "1" }, "-=1");
}

gridAnimation();

let blockSpacer = document.querySelectorAll(".wp-block-spacer");

let setMainSpaseHeight = () => {
	blockSpacer.forEach(item => {
		item.setAttribute("spacer-height", item.style.height);
	});
};

let changeSpacerHeight = () => {
	blockSpacer.forEach(item => {
		if (window.innerWidth > 1023) {
			item.style.height = item.getAttribute("spacer-height");
		} else {
			item.style.height = 0;
		}
	});
};

const anchors = document.querySelectorAll('a[href^="#"]');
const headerHeight = document.querySelector("header").offsetHeight;
const urlHash = location.hash;

for (let i = 0; i < anchors.length; i++) {
	anchors[i].addEventListener("click", e => {
		e.preventDefault();
		const href = anchors[i].getAttribute("href");

		if (href !== "#top") {
			const target = document.getElementById(href.replace("#", ""));

			const position =
				window.pageYOffset + target.getBoundingClientRect().top - headerHeight;
			/* eslint-disable */
			window.scroll({
				top: position,
				behavior: "smooth"
			});
		} else {
			window.scroll({
				top: 0,
				behavior: "smooth"
			});
			/* eslint-enable */
		}
	});
}

window.addEventListener("DOMContentLoaded", () => {
	if (urlHash) {
		setTimeout(function() {
			const id = urlHash.slice(1);
			const elem = document.getElementById(id);
			const info = elem.querySelector(".swainson-accordion__info");

			if (info) {
				info.classList.add("open");
			}

			const urlTarget = document.getElementById(urlHash.replace("#", ""));
			/* eslint-disable */
			const urlPosition =
				window.pageYOffset +
				urlTarget.getBoundingClientRect().top -
				headerHeight;
			window.scroll({
				top: urlPosition,
				behavior: "smooth"
			});
			/* eslint-enable */
		}, 600);
	}
});

const accordionItems = document.querySelectorAll(".swainson-accordion__item");

if (accordionItems) {
	accordionItems.forEach(el => {
		const img = el.querySelector(".swainson-accordion__image");
		const info = el.querySelector(".swainson-accordion__info");

		if (info) {
			info.addEventListener("click", () => {
				info.classList.toggle("open");
			});
		}

		if (img) {
			el.addEventListener("mousemove", e => {
				img.style.left = e.offsetX - img.offsetWidth / 2 + "px";
				img.style.top = e.offsetY - img.offsetHeight / 2 + "px";
			});
		}
	});
}

var textarea = document.querySelector("textarea");

if (textarea) {
	textarea.addEventListener("keydown", autosize);
}

function autosize() {
	var el = this;
	setTimeout(function() {
		el.style.cssText = "height:auto;";
		el.style.cssText = "height:" + el.scrollHeight + "px";
	}, 0);
}

window.onload = () => {
	if (blockSpacer) {
		setMainSpaseHeight();
		setTimeout(changeSpacerHeight, 100);
	}

	window.addEventListener(
		"resize",
		() => {
			if (blockSpacer) {
				changeSpacerHeight();
			}
		},
		true
	);
};

jQuery(document).ready(() => {
	/* eslint-disable */

	$(".team-section__title").each(function() {
		let teamTitle = gsap.timeline({
			scrollTrigger: {
				trigger: $(this),
				start: "top center"
			}
		});

		teamTitle.fromTo($(this), 1, { opacity: "0" }, { opacity: "1" });
	});

	$(".team-section__item").each(function() {
		let img = $(this).find("img");

		let teamAnimation = gsap.timeline({
			scrollTrigger: {
				trigger: $(this),
				start: "top center"
			}
		});

		teamAnimation.fromTo(img, 1, { width: 0 }, { width: "100%" });
	});

	$(".swainson-image__media").each(function() {
		let img = $(this).find("img");

		let imageAnimation = gsap.timeline({
			scrollTrigger: {
				trigger: $(this),
				start: "top center"
			}
		});

		imageAnimation.fromTo(
			img,
			0.3,
			{ opacity: "0", transform: "translateY(50px)" },
			{ opacity: "1", transform: "translateY(0)" }
		);
	});

	const formAddClass = e => {
		e.parent()
			.parent(".gfield")
			.addClass("active");
	};

	const formRemoveClass = e => {
		e.parent()
			.parent(".gfield")
			.removeClass("active");
	};

	const formItemChange = elem => {
		elem.each(function() {
			$(this).on("focus", function() {
				formAddClass($(this));
			});

			$(this).on("blur", function() {
				if ($(this).val().length == 0) {
					formRemoveClass($(this));
				}
			});

			if ($(this).val() != "") formAddClass($(this));
		});
	};

	$(document).bind("gform_post_render", function() {
		formItemChange($("input"));
		formItemChange($("textarea"));
	});

	formItemChange($("input"));
	formItemChange($("textarea"));
	/* eslint-enable */
});



// WEBPACK FOOTER //
// ./scripts/main.js